exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-53f6f{margin:2.4rem auto 1.2rem auto;max-width:10rem}.text-31045 h1{color:#191919;font:500 3rem/4rem XfinityStandard,Helvetica,Arial,sans-serif;letter-spacing:.02rem;font-weight:500}@media(max-width: 530px){.text-31045 h1{font-size:2.4rem;line-height:3.2rem}}.text-31045 p{color:#44484c;font:300 1.6rem/2.4rem XfinityStandard,Helvetica,Arial,sans-serif;letter-spacing:.02rem}.text-31045 p strong{font-weight:500}", ""]);

// Exports
exports.locals = {
	"loading": "loading-53f6f",
	"text": "text-31045"
};